module.exports = __webpack_public_path__ + "static/img/1062_small.92d31d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/1062_small.png
// module id = J2fm
// module chunks = 1